const remarkFieldMap = {
  purchase: 'purchase_remark',
  inspect: 'inspect_remark',
  delivery: 'delivery_remark'
}

export const planRemarkFields = Object.values(remarkFieldMap)

export function normalizePlanRemark(value) {
  return value == null ? '' : String(value)
}

export function hasPlanRemark(value) {
  return normalizePlanRemark(value).trim() !== ''
}

// 五个详情页共用：有绑定辅料时默认展开，否则按当前工种可见的要求判断；业务判断三项要求。
export function shouldExpandPlanRemark(item, visibleRequirements, isBusiness = false) {
  if (Array.isArray(item.material_bind) && item.material_bind.length > 0) return true

  const fields = isBusiness
    ? planRemarkFields
    : visibleRequirements.map(type => remarkFieldMap[type]).filter(Boolean)

  return fields.some(field => hasPlanRemark(item[field]))
}

export function getPlanRemarkSnapshot(item) {
  return planRemarkFields.reduce((snapshot, field) => {
    snapshot[field] = normalizePlanRemark(item[field])
    return snapshot
  }, {})
}
